import { ExplicitlyHideSearchBar, NavType, RFHeader } from '@chegg-me-components/header'
import {
  SecondaryNavLinks,
  SignedOutHeader,
} from '@chegg-me-components/signed-out-header'
import { useDefaultProps as useSignedOutHeaderDefaultProps } from '@chegg-me-components/signed-out-header-props'
import { withApollo } from '@chegg-web-tools/with-chegg'
import { Params } from '@src/pages/Workspace/types'
import { logout, showCheggAuthModal } from '@src/state/auth/actions'
import { getLoggedIn } from '@src/state/auth/selectors'
import { isOptimizelyClientReadySelector } from '@src/state/featureFlags/selectors'
import { getSiteConfig } from '@src/state/site/selectors'
import { SiteConfig } from '@src/state/site/types'
import { RootState } from '@src/state/types'
import useCheggHeaderSession from '@src/utils/hooks/useCheggHeader'
import { Location } from 'history'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'
import { Dispatch } from 'redux'
import styled from 'styled-components'

const CheggHeaderWrapper = styled.div`
  font-family: 'Aspira', 'Helvetica', 'Arial', 'Arimo', 'Liberation Sans', sans-serif;
  * {
    font-family: inherit;
  }
`

interface StateProps {
  location: Location<any>
  siteConfig: SiteConfig
  loggedIn: boolean
  clientReady: boolean
}

interface DispatchProps {
  signin: () => void
  logout: () => void
}

export type CheggHeaderProps = StateProps & DispatchProps

export const CheggHeader: React.FC<CheggHeaderProps> = ({
  location,
  siteConfig,
  signin,
  logout,
  loggedIn,
  clientReady,
}) => {
  const { user, pageTrackId } = useCheggHeaderSession(
    location,
    siteConfig.cheggEnvUrl,
    loggedIn
  )

  const signedOutHeaderDefaultProps = useSignedOutHeaderDefaultProps()

  const secondaryNavLinks: SecondaryNavLinks = [
    {
      text: 'For educators',
      href: `uversity`,
    },
    {
      text: 'Sign in',
      href: `auth?action=login&redirect=${encodeURIComponent(window.location.href)}`,
      onClick: e => handleClick(e, signin),
    },
    {
      text: 'Help',
      href: `contactus`,
    },
  ]

  const handleClick = (e: React.MouseEvent<Element, MouseEvent>, cb: () => void) => {
    e.preventDefault()
    cb()
  }

  const commonProps = {
    envUrl: siteConfig.cheggEnvUrl,
    serverRenderAsMobile: false,
    mainContentId: 'main',
  }

  const signedInProps = {
    headerDataSource: siteConfig.meBffUrl,
    skipDataQuery: true,
    navType: NavType.writing,
    activeSubLink: 'None',
    user,
    pageTrackId,
    onClickSignOut: (e: React.MouseEvent<Element, MouseEvent>) => handleClick(e, logout),
    children: ExplicitlyHideSearchBar,
  }

  if (!clientReady) {
    return <CheggHeaderWrapper />
  }

  return (
    <CheggHeaderWrapper>
      {!loggedIn ? (
        <SignedOutHeader
          {...signedOutHeaderDefaultProps}
          {...commonProps}
          secondaryNavLinks={secondaryNavLinks}
        />
      ) : (
        <RFHeader {...commonProps} {...signedInProps} />
      )}
    </CheggHeaderWrapper>
  )
}

const mapStateToProps = (state: RootState, ownProps: RouteComponentProps<Params>) => ({
  location: ownProps.location,
  siteConfig: getSiteConfig(state),
  loggedIn: getLoggedIn(state),
  clientReady: isOptimizelyClientReadySelector(state),
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  signin: () => dispatch(showCheggAuthModal({ experience: 'login' })),
  logout: () => dispatch(logout({})),
})

export default withApollo(
  withRouter(
    connect<StateProps, DispatchProps, RouteComponentProps<Params>>(
      mapStateToProps,
      mapDispatchToProps
    )(CheggHeader)
  ),
  false
)



// WEBPACK FOOTER //
// ./src/components/Header/CheggHeader.tsx